import React from "react";
import createSvgIcon from "@material-ui/core/utils/createSvgIcon";

/**
 * author: Google
 * id 2AD1736A-2142-4E3D-BA70-9CF8584C366D
 * name cellphone-off
 * version: 2.4.85
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/cellphone-off.svg
 * tags
 * - Cellphone / Phone 
 * - Device / Tech 
 */
export const CellphoneOffIcon = createSvgIcon(<><path d="M2.38,1.73L1.11,3L5,6.89V21A2,2 0 0,0 7,23H17A2,2 0 0,0 19,21V20.89L20.84,22.73L22.11,21.46M17,19H7V8.89L17,18.89V19M17,5V13.8L19,15.8V3A2,2 0 0,0 17,1H7C6.28,1 5.6,1.37 5.24,2L8.24,5H17Z" /></>, 'CellphoneOffIcon');
export default CellphoneOffIcon